export const Brand = () => {
  return (
    <h4 className="text-muted fw-normal text-center" data-aos="fade-up">
      NGN<span className="fw-bold">360</span>
    </h4>
  );
};
